import { style } from '@vanilla-extract/css';
import { radiusVars } from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';
import {
  CHECKBOX_CONTROL_SIZE,
  SELECTION_CONTROL_ICON_SIZE,
  selectionControlBase,
} from '../../../_shared/styles/selectionControl';

export const checkboxIndicatorClass = style({
  ...selectionControlBase,
  width: CHECKBOX_CONTROL_SIZE,
  height: CHECKBOX_CONTROL_SIZE,
  borderRadius: radiusVars.sm,
  selectors: {
    '&[data-state=checked], &[data-state=indeterminate]': {
      backgroundColor: semanticTokenVars.surface.background.brand.default.base,
      borderColor: semanticTokenVars.surface.background.brand.default.base,
    },
    '&[data-disabled]': {
      borderColor: semanticTokenVars.border.neutral.default.disabled,
    },
    '&[data-disabled][data-state=checked], &[data-disabled][data-state=indeterminate]':
      {
        backgroundColor:
          semanticTokenVars.surface.background.neutral.default.idle,
        borderColor: semanticTokenVars.border.neutral.default.disabled,
      },
  },
});

export const checkboxIndicatorIconClass = style({
  fontSize: SELECTION_CONTROL_ICON_SIZE,
  color: semanticTokenVars.content.onBrand.default,
});
